import Link from "next/link";

import MegaMenu from "./megamenu";
import { MenuItemProps } from "./navigation.config";

type NavItemProps = {
  item: MenuItemProps;
  pathname: string;
  handleClose: () => void;
};

export default function NavItem({ item, pathname, handleClose }: NavItemProps) {
  return item.items ? (
    <MegaMenu item={item} pathname={pathname} handleClose={handleClose} />
  ) : (
    <Link href={item.url} className={`nav-link${pathname === item.url ? " active" : ""}`} onClick={handleClose}>
      {item.label}
    </Link>
  );
}
